function percentageInView(element) {
    const elementBoundingRect = element.getBoundingClientRect();

    // the element is below the viewport
    if (elementBoundingRect.top > window.innerHeight) {
        return 0;
    }

    // the element is above the viewport
    if (elementBoundingRect.bottom <= 0) {
        return 0;
    }

    // the gap between the top of the viewport and the top edge of the element
    const topGap = elementBoundingRect.top <= 0 ? 0 : elementBoundingRect.top;

    // the height of the viewport covered between the top edge of the viewport
    // and the bottom edge of the element
    const heightCovered = elementBoundingRect.bottom > window.innerHeight ? window.innerHeight : elementBoundingRect.bottom;

    const heightWithinViewport = heightCovered - topGap;

    return  heightWithinViewport / elementBoundingRect.height * 100;
}

function getAllButtons() {

    return [...document.querySelectorAll('[data-nav-button-for-section]')];
}

function getSectionId(section) {

    return section.getAttribute('data-section-id');
}

function getButtonId(section) {

    return section.getAttribute('data-nav-button-for-section');
}

function isSticky(el) {

    return el.getAttribute('data-is-sticky');
}

function activateButton(button) {
    button.classList.add('aboutNav__button--active');

    if (isSticky(button)) {
        button.scrollIntoView();
    }
}

function deactivateButton(button) {
    button.classList.remove('aboutNav__button--active');
}

function buttonMatchesSectionId(button, sectionId) {

    return getButtonId(button) == sectionId;
}

function renderNav(entries, observer) {
    const sections = [...document.querySelectorAll('[data-section-id]')];
    const buttons = getAllButtons(0);

    sections.sort((a, b) => percentageInView(b) - percentageInView(a));

    const first = sections[0];

    if (percentageInView(first) > 0) {
        const sectionId = getSectionId(first);

        buttons.filter(button => buttonMatchesSectionId(button, sectionId)).forEach(activateButton);
        buttons.filter(button => !buttonMatchesSectionId(button, sectionId)).forEach(deactivateButton);
    } else {
        buttons.forEach(deactivateButton);
    }
}

function init() {
    const sections = [...document.querySelectorAll('[data-section-id]')];

    const options = {
        root: null,
        threshold: [0, 0.25, 0.5, 0.75, 1],
    };

    const observer = new IntersectionObserver(renderNav, options);
    
    sections.forEach(section => observer.observe(section));
}

$(document).ready(init);
